/*
 * @Author: qian.tang
 * @Date: 2023-12-04 11:30:55
 * @LastEditors: Qian Tang qian@itrazotracetech.com
 * @LastEditTime: 2023-12-04 11:42:15
 * @FilePath: \itrazo-portal-dev\src\containers\Pages\AssetManagement\apis\DisposalAPI.tsx
 * @Description: 
 * 
 * Copyright (c) 2023 by ${git_name_email}, All Rights Reserved. 
 */
import { ASSET_MANAGEMENT_API as AM_API } from "utilities/AdiApi";
import { logError } from '../../RelationshipManagement/utilities/functions'
import { getBizCode } from "utilities/Functions/GlobalHelperFunctions";

const DisposalAPI = {

  getAll: async () => {

    try {
      const url = `${getBizCode()}/disposals`
      const res = await AM_API.get(url)
      console.log('getAll disp res', res)
      return res.data.Items
    } catch (e) {
      logError(e)
      throw e
    }

  },
  disposeAsset: async (payload: any) => {

    try {
      const url = `${getBizCode()}/disposals`
      const res = await AM_API({
        url,
        method: "POST",
        data: payload
      })
      console.log('disposeAsset res', res)
      return res
    } catch (e) {
      logError(e)
      throw e
    }

  },
  // updateGeofence: async (payload: any) => {

  //   try {
  //     const url = `${getBizCode()}/geofence`
  //     const res = await AM_API({
  //       url,
  //       method: "PUT",
  //       data: payload
  //     })
  //     console.log('updateGeofence res', res)
  //     return res
  //   } catch (e) {
  //     logError(e)
  //     throw e
  //   }

  // },
  // deleteGeofence: async (location_name: string) => {

  //   try {
  //     const url = `${getBizCode()}/geofence?location_name=${location_name}`
  //     const res = await AM_API.delete(url)
  //     console.log('deleteGeofence res', res)
  //     return res
  //   } catch (e) {
  //     logError(e)
  //     throw e
  //   }

  // },


}

export default DisposalAPI